/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
export var OperatingSystemType;
(function (OperatingSystemType) {
    OperatingSystemType["Android"] = "android";
    OperatingSystemType["Ios"] = "ios";
    OperatingSystemType["Linux"] = "linux";
    OperatingSystemType["Macos"] = "macos";
    OperatingSystemType["Windows"] = "windows";
    OperatingSystemType["Xbox"] = "xbox";
})(OperatingSystemType || (OperatingSystemType = {}));
//# sourceMappingURL=OperatingSystemType.js.map